import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

export interface DialogSolicitarModificacionData {
    apId: number;
}

@Component({
    selector: "dialog-solicitar-modificacion",
    templateUrl: "./dialog-solicitar-modificacion.component.html",
    styleUrls: ["./dialog-solicitar-modificacion.component.scss"],
    standalone: false
})
export class DialogSolicitarModificacionComponent implements OnInit {
    formSolicitarModificacion: FormGroup;
    maxLength = 250;
    minLength = 10;

    constructor(
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<DialogSolicitarModificacionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogSolicitarModificacionData,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.formSolicitarModificacion = this.fb.group({
            motivo: [
                "",
                [Validators.required, Validators.minLength(this.minLength), Validators.maxLength(this.maxLength)]
            ]
        });
    }

    get motivo() {
        return this.formSolicitarModificacion.get("motivo");
    }

    get caracteresRestantes(): number {
        const motivoValue = this.motivo?.value || "";
        return this.maxLength - motivoValue.length;
    }

    get puedeConfirmar(): boolean {
        return this.formSolicitarModificacion.valid && this.motivo?.value?.length >= this.minLength;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm(): void {
        if (this.puedeConfirmar) {
            this.dialogRef.close({
                confirmado: true,
                motivo: this.motivo?.value
            });
        }
    }
}
